import React, { useEffect, useState, useRef } from "react";
import { useRouter } from "next/router";
import { useStoreLogin } from "../../../store/login";
import { useStoreSnackbar } from "../../../store/snackbar";
import Both from "../../../components/login/Both";
import { useStoreLoader } from "../../../store/loader";
import NotFound from "../../../components/ErrorPage/NotFound";
import { TbCurrencyRupee } from "react-icons/tb";
import { FaRegDotCircle } from "react-icons/fa";
import {
  getInitialData,
  getProductById,
  getProductBatch,
  initiateOrderPost,
  getPaymentNodes,
  applyCouponCode,
  checkDiscountCode,
  getpostal,
  putAddress,
} from "../../../service/apiFetch";
export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps = async () => {
  const initialData = await getInitialData("das", { getOnlyWebsiteData: true });
  // console.log("error", initialData);
  return {
    props: {
      websiteData: initialData?.websiteData || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
    },
  };
};

export default function Index({ }) {
  const router = useRouter();
  const [productResponse, setProductResponse] = useState({});
  const [productId, setProductId] = useState(null);
  const [customError, setCustomError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [currentScreen, setCurrentScreen] = useState("LOGIN");
  const [emiOptions, setEmiOptions] = useState(null);
  const { user, authToken } = useStoreLogin();
  const [page, setPage] = useState("reviewPage");
  const [couponField, setCouponField] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const isloading = useStoreLoader((state) => state.isloading);
  const [loading, setLoading] = useState(false);
  const apiUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
  const orderId = useRef(null);
  const [discount, setDiscount] = useState({
    discountDetail: {
      discountCode: couponCode,
      type: "COUPON",
    },
  });

  const [coupon, setCoupon] = useState({
    show: false,
    code: "",
    apply: false,
    amount: "",
    discountAmount: "",
  });

  const [placeOrderData, setPlaceOrderData] = useState({
    user: "",
    order: {
      stream: "",
      customParams: "",
      course: "",
      session: "",
      center: "",
      batch: "",
      store: "",
      product: [],
      relProductCategory: "",
      productCategory: "",
      productType: "",
      total: "",
      // shippingCost: "",
      shippingTotal: "",
      tracer: { form: "Website-sales-order" },
      isShipping: true,
    },
  });
  // *****formstate**********

  // const [addresses, setAddresses] = useState(() => {
  //   const defaultAddress = {
  //     address: "",
  //     postalCode: "",
  //     city: "",
  //     selectedPost: "",
  //     country: "India",
  //     landmark: "",
  //     district: "",
  //     state: "",
  //   };

  //   return {
  //     shippingAddress: user?.shippingAddress || defaultAddress,
  //     billingAddress:
  //       user?.billingAddress || user?.shippingAddress || defaultAddress,
  //   };
  // });

  const [sameAsShipping, setSameAsShipping] = useState(false);
  const [addressModal, setAddressModal] = useState("close");
  const [error, setError] = useState();
  // const [selectedBlock, setSelectedBlock] = useState("");

  const [selectedBlock, setSelectedBlock] = useState({
    shippingAddress: user?.shippingAddress?.selectedPost || "",
    billingAddress:
      user?.billingAddress?.selectedPost ||
      user?.shippingAddress?.selectedPost ||
      "",
  });
  const [shippingPostOffices, setShippingPostOffices] = useState([]);
  const [billingPostOffices, setBillingPostOffices] = useState([]);
  const [selectedMedium, setSelectedMedium] = useState("");

  const availableMedium = productResponse?.customParam?.medium
    ? productResponse.customParam.medium.split(",")
    : [];

  const validateAndProceed = (nextFn) => {
    if (availableMedium?.length > 0 && !selectedMedium) {
      alert("Please select a language before continuing.");
      return;
    }

    // const updatedProduct = {
    //   ...productResponse,
    //   customParam: {
    //     ...productResponse.customParam,
    //     medium: selectedMedium || productResponse.customParam.medium,
    //   },
    // };

    nextFn();
  };

  const defaultAddress = {
    address: "",
    postalCode: "",
    city: "",
    selectedPost: "",
    country: "India",
    landmark: "",
    district: "",
    state: "",
  };

  const [addresses, setAddresses] = useState({
    shippingAddress: defaultAddress,
    billingAddress: defaultAddress,
  });

  useEffect(() => {
    if (addressModal === "open" && user?.id) {
      const stored = localStorage.getItem(user.id);

      if (stored) {
        try {
          const parsed = JSON.parse(stored);

          if (parsed?.address) {
            setAddresses({
              shippingAddress: parsed.address.shippingAddress || defaultAddress,
              billingAddress: parsed.address.billingAddress || defaultAddress,
            });
          } else {
            setAddresses({
              shippingAddress: defaultAddress,
              billingAddress: defaultAddress,
            });
          }
        } catch (err) {
          console.error("Invalid localStorage data", err);
          setAddresses({
            shippingAddress: defaultAddress,
            billingAddress: defaultAddress,
          });
        }
      } else {
        setAddresses({
          shippingAddress: user?.address?.shippingAddress || defaultAddress,
          billingAddress: user?.address?.billingAddress || defaultAddress,
        });
      }
    }
  }, [addressModal, user?.id]);

  //*********end form state******** */

  const updatePlaceOrderData = async (productResponse) => {
    // console.log("productResponse", productResponse);

    if (productResponse) {
      try {
        let batch;

        if (productResponse.haveBatch) {
          const data = await getProductBatch(productResponse.id);

          if (data?.error) {
            console.log("batch error");
          } else if (data && data.length) {
            batch = data[0];
          }
        }
        let orderTotal = calculateTotalCost(productResponse);

        setPlaceOrderData((prevData) => ({
          ...prevData,
          order: {
            ...prevData.order,
            stream: productResponse?.stream?.id || productResponse.stream,
            course: productResponse?.course?.id || productResponse.course,
            session: productResponse?.session?.id || productResponse.session,
            center: productResponse?.center?.id || productResponse.center,
            // batch: productResponse?.haveBatch ? batch.id || null : null,
            isShipping:
              productResponse.category === "659d195b4278df2b9163e8c6"
                ? true
                : false,
            relProductCategory: productResponse.category,
            productCategory: productResponse.category,
            productType: productResponse.type,
            shippingTotal: productResponse.shippingCost,
            store: productResponse.store,
            product: [productResponse.id],
            total: orderTotal,
          },
        }));
      } catch (error) {
        console.error("Error updating placeOrderData:", error);
      }
    }
  };

  const calculateTotalCost = (productResponse) => {
    const cost = parseFloat(productResponse.cost);
    const shipAmt = parseFloat(productResponse.shippingCost || 0);
    const cgst = parseFloat(productResponse?.tax?.cgst || 0);
    const sgst = parseFloat(productResponse?.tax?.sgst || 0);
    if (coupon?.amount && coupon?.apply) {
      const totalAmount = coupon.amount + shipAmt;
      return totalAmount;
    } else {
      const totalTax =
        parseFloat(((cost * cgst) / 100).toFixed(2)) +
        parseFloat(((cost * sgst) / 100).toFixed(2));
      const totalAmount = cost + totalTax + shipAmt;
      return totalAmount;
    }
  };

  useEffect(() => {
    if (router.query.productId) {
      setProductId(router.query.productId);
      getProductdata(router.query.productId);
    }
  }, [router]);
  const getProductdata = async (prodId) => {
    let data;
    try {
      setLoading(true);
      const params = {
        populate: "course,stream,center,session",
      };
      data = await getProductById(prodId, params);

      // console.log("product response", data);
      if (!data || data?.error?.message) {
        setCustomError("Product Not found with given product id");
      } else {
        setProductResponse(data);
        updatePlaceOrderData(data);
      }
      setLoading(false);
    } catch (error) {
      setCustomError("Product Not found with given product id");
      setLoading(false);
      console.log(error);
    }
  };

  const initiateOrder = async () => {
    try {
      // const currentUser = updatedUser || user;
      if (user && authToken) {
        setIsOpen(false);
        calculateTotalCost(productResponse);

        // const updatedOrderData = {
        //   ...placeOrderData,
        //   user: {
        //     ...user,
        //     address: addresses,
        //   },

        //   order: {
        //     ...placeOrderData.order,
        //     shippingAddress: addresses.shippingAddress,
        //     billingAddress: addresses.billingAddress,
        //   },
        // };

        const updatedOrderData = {
          ...placeOrderData,
          user: {
            ...user,
            address: addresses,
          },
          order: {
            ...placeOrderData.order,
            ...(productResponse.category === "659d195b4278df2b9163e8c6" && {
              shippingAddress: addresses.shippingAddress,
              billingAddress: addresses.billingAddress,
            }),
            customParams: {
              ...placeOrderData.order.customParams,
              medium:
                selectedMedium ||
                placeOrderData.order.customParams?.medium ||
                "",
            },
          },
        };

        setPlaceOrderData(updatedOrderData);

        setLoading(true);

        const data = await initiateOrderPost(updatedOrderData);

        if (!data || data?.error || data?.error?.message) {
          if (data?.details?.order) {
            orderId.current = data.details.order?.id;
          } else {
            console.log(data?.error?.message);
            setCustomError("Order Initiate error");
          }
        } else {
          orderId.current = data?.id;
        }

        if (!orderId.current) {
          setPage("orderInitiated");
        }

        if (couponCode && orderId.current) {
          applyCouponCodeFun(orderId.current);
        }

        const paymentNode = await getPaymentNodesFun(orderId.current);
        if (paymentNode) {
          getGatewayUrl(paymentNode, orderId.current);
        } else {
          console.error("No payment node found for this order.");
        }
      } else {
        setIsOpen(true);
        setCurrentScreen("LOGIN")
      }
    } catch (e) {
      setLoading(false);
      alert("Error in initiating order");
      console.error(e);
    }
  };

  function getPaymentNodesFun(orderId) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await getPaymentNodes(orderId);

        if (!data || data?.error || data?.error?.message) {
          setCustomError("Payment Node Error");
          return reject("Payment Node Error");
        }

        if (!data.length) {
          setCustomError("Payment Node Error: No payment nodes found");
          return reject("Payment Node Error: No payment nodes found");
        }

        // Now it's safe to destructure data[0]
        let { id, dueAmount, orderNo, store } = data[0];

        // Apply coupon if applicable
        if (coupon?.apply && coupon?.amount) {
          dueAmount = coupon.amount;
        }

        resolve({ id, dueAmount, orderNo, store });
      } catch (error) {
        console.error("Error in getPaymentNodesFun:", error);
        setCustomError(
          "Payment Node Error: " + (error.message || "Unknown error")
        );
        reject(error);
      }
    });
  }
  function getGatewayUrl(paymentNode, orderId) {
    const { id, dueAmount, orderNo, store } = paymentNode;
    if (parseInt(dueAmount) < 0.1) {
      router.push("/course");
    } else {
      let url = `${apiUrl}/api/sales/order/make-online-payment?storeId=${store}&orderId=${orderId}&nodeId=${id}&orderNo=${orderNo}&totalAmount=${dueAmount}&redirectUrl=${apiUrl}/api/sales/order/online-payment-response/${orderId}&cancelUrl=${apiUrl}/api/sales/order/online-payment-cancel-response/${orderId}&responsePreviewUrl=${apiUrl}/api/sales/order/online-payment-response/${orderId}`;
      window.location.href = url;
    }
  }

  const openCouponField = async () => {
    if (user && authToken) {
      setCouponField(true);
    } else {
      setIsOpen(true);
      setCurrentScreen("LOGIN")
    }
  };

  const handleSubmitCoupon = (e) => {
    e.preventDefault();
    checkDiscountCodeFun(productId);
  };

  const handleRemoveBtn = () => {
    setCoupon({
      show: false,
      code: "",
      apply: false,
      amount: "",
      discountAmount: "",
    });
    setCouponCode("");
    setIsCouponApplied(false);
    useStoreSnackbar.getState().showSnackbar({
      description: "Remove Coupon",
      title: "Remove",
      color: "danger",
    });
  };

  const handleCouponChange = (e) => {
    const newCouponCode = e.target.value;
    setCouponCode(newCouponCode);

    setDiscount((prevDiscount) => ({
      ...prevDiscount,
      discountDetail: {
        ...prevDiscount.discountDetail,
        discountCode: newCouponCode,
      },
    }));
  };

  async function applyCouponCodeFun(orderId) {
    const data = await applyCouponCode(orderId, discount);
    if (!data || data?.error || data?.error?.message) {
      setCustomError("Order Discount Error");
    } else if (data) {
      return data;
    }
  }

  async function checkDiscountCodeFun(productId) {
    const data = await checkDiscountCode(productId, couponCode);
    if (!data || data?.error || data?.error?.message) {
      useStoreSnackbar.getState().showSnackbar({
        description: data?.details?.message,
        title: "Error",
        color: "danger",
      });
      return;
    }
    useStoreSnackbar.getState().showSnackbar({
      description: "Successfully Applied",
      title: "Coupon Used",
      color: "success",
    });
    setIsCouponApplied(true);
    coupon.apply = true;
    coupon.discountAmount = data.discountAmount;
    if (data?.discountType === "PER" && data?.discountAmount <= 100) {
      const CalculatedCoupanAmount =
        productResponse.cost * (1 - coupon.discountAmount / 100);
      setCoupon((prevCoupon) => ({
        ...prevCoupon,
        apply: true,
        discountAmount: productResponse.cost * (coupon.discountAmount / 100),
        amount: CalculatedCoupanAmount,
      }));
    } else {
      const CalculatedCoupanAmount =
        productResponse.cost - coupon.discountAmount;
      setCoupon((prevCoupon) => ({
        ...prevCoupon,
        apply: true,
        discountAmount: coupon.discountAmount,
        amount: CalculatedCoupanAmount,
      }));
    }
  }

  function goToDashboard() {
    let url = null;
    if (!authToken) {
      url = "https://clcweb.in/student/auth/login";
    } else {
      const tk = authToken;

      const client = user?.client;
      url = `https://clcweb.in/student/auth/redirect?token=${tk}&path=student/dashboard&client=${client}`;
    }
    window.open(url, "_blank");
  }

  if (loading) {
    return (
      <div className="animate-pulse min-h-[455px] flex justify-center py-12">
        <div className="w-full sm:w-[80%] lg:w-[60%] xl:w-[50%] mx-auto rounded-[5px] overflow-hidden">
          <div className="bg-gray-200 h-16 rounded-t-md" />
          <div className="bg-white p-6 space-y-4">
            <div className="h-6 bg-gray-200 rounded w-1/3" />
            <div className="h-4 bg-gray-200 rounded w-2/3" />
            <div className="h-4 bg-gray-200 rounded w-1/2" />
            <div className="h-4 bg-gray-200 rounded w-3/4" />
            <div className="h-12 bg-gray-200 rounded-lg mt-6" />
          </div>
        </div>
      </div>
    );
  }

  const buyWithAddress = () => {
    if (user) {
      const shippingAddr = user?.address?.shippingAddress || {
        address: user?.address?.billingAddress?.address || "",
        postalCode: user?.address?.billingAddress?.postalCode || "",
        city: user?.address?.billingAddress?.city || "",
        selectedPost: user?.address?.billingAddress?.selectedPost || "",
        country: "India",
        landmark: user?.address?.billingAddress?.landmark || "",
        district: user?.address?.billingAddress?.district || "",
        state: user?.address?.billingAddress?.state || "",
      };

      const billingAddr = user.address.billingAddress || { ...shippingAddr };

      setAddresses({
        shippingAddress: shippingAddr,
        billingAddress: billingAddr,
      });

      if (shippingAddr.postalCode?.length === 6) {
        fetchAddressDetails(shippingAddr.postalCode, "shippingAddress");
      }
      if (
        billingAddr.postalCode?.length === 6 &&
        billingAddr.postalCode !== shippingAddr.postalCode
      ) {
        fetchAddressDetails(billingAddr.postalCode, "billingAddress");
      }

      setAddressModal("open");
    } else {
      setIsOpen(true);
      setCurrentScreen("LOGIN")
    }
  };

  // console.log("addresses", addresses);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { shippingAddress, billingAddress } = addresses;

    const requiredFields = [
      "address",
      "postalCode",
      "city",
      "landmark",
      "state",
      "country",
    ];

    const isValidAddress = (address) =>
      requiredFields.every((field) => address[field]?.trim());

    if (!isValidAddress(shippingAddress) || !isValidAddress(billingAddress)) {
      setError("Please fill all required address fields.");
      alert(
        "Please complete both shipping and billing addresses before proceeding."
      );
      return;
    }

    setError("");

    const apiAddress = {
      address: shippingAddress,
      permanantAddress: billingAddress,
    };

    try {
      // setLoading(true);
      // const response = await putAddress(apiAddress);
      // console.log("Submitted Addresses:", apiAddress);

      // setAddressModal("close");

      // initiateOrder();

      setLoading(true);
      const response = await putAddress(apiAddress);

      console.log("Submitted Addresses:", response);

      // Update user store with new addresses
      useStoreLogin.getState().updateUser({
        ...user,
        address: {
          ...user.address,
          shippingAddress: response?.address,
          billingAddress: response?.permanantAddress,
        },
      });

      // const updatedUserData = {
      //   ...user,
      //   shippingAddress: shippingAddress,
      //   billingAddress: billingAddress,
      // };

      // useStoreLogin.getState().updateUser(updatedUserData);

      setAddressModal("close");
      initiateOrder();
    } catch (error) {
      setLoading(false);
      console.error("Failed to update address:", error);
      setError("Failed to update address. Please try again.");
    }
  };

  const handleSameAsShipping = (e) => {
    const isChecked = e.target.checked;
    setSameAsShipping(isChecked);

    if (isChecked) {
      // Copy shipping address to billing
      setAddresses((prev) => ({
        ...prev,
        billingAddress: JSON.parse(JSON.stringify(prev.shippingAddress)),
      }));

      // Copy shipping post offices to billing
      setBillingPostOffices([...shippingPostOffices]);

      // Update selected block for billing
      setSelectedBlock((prev) => ({
        ...prev,
        billingAddress: prev.shippingAddress,
      }));
    } else {
      // Reset billing address when unchecked
      setAddresses((prev) => ({
        ...prev,
        billingAddress: {
          address: "",
          postalCode: "",
          city: "",
          selectedPost: "",
          country: "India",
          landmark: "",
          district: "",
          state: "",
        },
      }));
      setBillingPostOffices([]);
      setSelectedBlock((prev) => ({
        ...prev,
        billingAddress: "",
      }));
    }
  };

  const fetchAddressDetails = async (postalCode, type) => {
    if (postalCode.length === 6) {
      try {
        setLoading(true);
        const data = await getpostal(postalCode);
        // console.log("📌 API Response:", data);

        // Ensure data is an array and has at least one element
        if (!Array.isArray(data) || data.length === 0) {
          // console.error("❌ No data found for this pincode.");
          return;
        }

        // Extracting District, State, and Block (for city)
        const { District, State, Block } = data[0];

        // Setting the post offices (entire data array)
        if (type === "shippingAddress") {
          setShippingPostOffices(data);
        } else {
          setBillingPostOffices(data);
        }
      } catch (error) {
        console.error("❌ Error fetching address details:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChange = (e, type) => {
    const { name, value } = e.target;
    setAddresses((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [name]: value,
      },
    }));

    if (name === "postalCode" && value.length === 6) {
      fetchAddressDetails(value, type);
    }
  };

  const handleBlockSelect = (e, type) => {
    const selectedName = e.target.value;

    const relevantPostOffices =
      type === "shippingAddress" ? shippingPostOffices : billingPostOffices;

    const selected = relevantPostOffices.find(
      (block) => block.Name === selectedName
    );

    if (selected) {
      setAddresses((prev) => ({
        ...prev,
        [type]: {
          ...prev[type],
          city: selected.Block || "",
          district: selected.District || "",
          state: selected.State || "",
          selectedPost: selected.Name,
        },
      }));

      // Update selectedBlock for current type
      setSelectedBlock((prev) => ({
        ...prev,
        [type]: selected.Name,
      }));

      // If same as shipping is checked and we're updating shipping, update billing too
      if (sameAsShipping && type === "shippingAddress") {
        setAddresses((prevAddr) => ({
          ...prevAddr,
          billingAddress: {
            ...prevAddr.billingAddress,
            city: selected.Block || "",
            district: selected.District || "",
            state: selected.State || "",
            selectedPost: selected.Name,
          },
        }));

        setSelectedBlock((prev) => ({
          ...prev,
          billingAddress: selected.Name,
        }));
      }
    }
  };

  return (
    <section
      id="courseBuy "
      className=" min-h-[455px] flex justify-center flex-col"
    >
      {productResponse?.error ? (
        <div>
          <NotFound
            errorType={productResponse?.details?.error?.message}
            errorCode={productResponse?.details?.statusCode}
          />
        </div>
      ) : (
        <div className="mx-[6px] px-[1rem] lg:px-[3rem]">
          <div className="grid grid-rows">
            <div className="grid grid-cols-12">
              <div className="col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="w-full flex justify-center py-8">
                  {page === "reviewPage" && (
                    <div className="w-full sm:w-[80%] lg:w-[60%] xl:w-[50%] mx-auto block shadow-xl rounded-[5px] p-0 transition-all duration-500 hover:shadow-2xl">
                      <div
                        style={{ textAlign: "center" }}
                        className="w-full bg-[var(--bg-color)] rounded-t-md text-[#000000] text-[20px] lg:text-[30px]  sm:text-left px-3 py-3 shadow-lg transform transition-all duration-300 "
                      >
                        {productResponse?.title}
                      </div>

                      <div className="px-4 mt-2 bg-white rounded-b-lg shadow-md hover:shadow-xl transition-shadow duration-300 ease-in-out">
                        {/* <div className="flex items-center  text-lg font-semibold text-[#6d6d6d] transition-all duration-300 hover:text-[#29cfce] ">
                          <i className="pi pi-chevron-circle-right text-xl text-secondary"></i>
                          <div>{productResponse?.title}</div>
                        </div> */}
                        {productResponse && (
                          <div className="flex flex-col gap-4 mt-3">
                            {productResponse.mrp > productResponse.cost ? (
                              <div className="flex gap-2 items-center ">
                                <FaRegDotCircle className="mr-3 md:text-lg text-sm text-[#7c8ec5]" />
                                <span className="text-xl lg:text-2xl text-[#0E8872] font-semibold">
                                  MRP:
                                </span>
                                <span className="md:text-lg text-sm">
                                  INR
                                  <del className="text-red-600md:text-lg text-sm">
                                    {productResponse.mrp}
                                  </del>
                                </span>
                                {/* 
                                 &#8377;
                                 <span className="text-sm text-green-500 font-semibold">
                                (
                                {(
                                  ((productResponse.mrp -
                                    productResponse.cost) /
                                    productResponse.mrp) *
                                  100
                                ).toFixed(2)}
                                % OFF)
                              </span> */}
                              </div>
                            ) : (
                              ""
                            )}

                            <div className="flex gap-2 items-center text-md mt-2">
                              <FaRegDotCircle className="mr-3 lg:text-2xl text-xl text-[#7c8ec5]" />
                              <span className="md:text-lg text-sm text-[#0E8872] font-semibold">
                                Cost:
                              </span>
                              <span className="md:text-lg text-sm">
                                INR {productResponse.cost}/- (inc. 18 % GST)
                              </span>
                            </div>

                            {productResponse?.shippingCost > 0 && (
                              <div className="flex gap-2 items-center text-md">
                                <FaRegDotCircle className="mr-3 text-[#7c8ec5]" />
                                <div className="md:text-lg text-sm">
                                  <span className="text-[#0E8872] font-semibold">
                                    Shipping Charges:{" "}
                                  </span>{" "}
                                  {productResponse.shippingCost}
                                </div>
                                {/* <span className="text-sm">
                              
                                </span> */}
                              </div>
                            )}

                            {productResponse?.shippingCost > 0 && (
                              <div className="flex gap-2 text-md">
                                <FaRegDotCircle className="mr-3 text-[#7c8ec5]" />
                                <span className="md:text-lg text-sm text-[#0E8872] font-semibold">
                                  Total Payable Amount:
                                </span>
                                {productResponse.shippingCost ? (
                                  <span className="text-black md:text-lg text-sm">
                                    {Number(productResponse.cost) +
                                      Number(productResponse.shippingCost)}
                                  </span>
                                ) : (
                                  <span className="text-black md:text-lg text-sm">
                                    ₹{Number(productResponse.cost)}
                                  </span>
                                )}
                              </div>
                            )}

                            {productResponse?.category ===
                              "659d195b4278df2b9163e8c6" ? (
                              ""
                            ) : (
                              <div className="text-right cursor-pointer">
                                <span
                                  role="button"
                                  tabIndex={0}
                                  className=" text-[#25429e]  text-base font-semibold transition-colors duration-300 ease-in-out"
                                  // onClick={() => setCouponField(true)}
                                  // onKeyDown={(e) => {
                                  //   if (e.key === "Enter" || e.key === " ") {
                                  //     setCouponField(true);
                                  //   }
                                  // }}
                                  onClick={openCouponField}
                                >
                                  HAVE A COUPON CODE?
                                </span>

                                {couponField && (
                                  <div className="couponField border-b-1 border-black py-1 px-3 border-400 flex justify-between  transition-all duration-300 ease-in-out ">
                                    <input
                                      type="text"
                                      value={couponCode}
                                      disabled={isCouponApplied}
                                      onChange={handleCouponChange}
                                      placeholder="Enter Coupon Code"
                                      className={`rounded-lg px-4 w-full bg-white text-black focus:bg-[] focus:outline-none ${isCouponApplied ? "opacity-30" : ""
                                        }`}
                                      style={{ paddingLeft: "10px" }}
                                    />

                                    {!isCouponApplied &&
                                      coupon.discountAmount == "" ? (
                                      <button
                                        className="text-white bg-[#25429e] hover:bg-[#29589e]  border-1 px-6 text-xs py-1 my-1 rounded-lg  transition-all duration-300 ease-in-out"
                                        onClick={handleSubmitCoupon}
                                      >
                                        Apply
                                      </button>
                                    ) : (
                                      <button
                                        className="text-white bg-[#25429e] hover:bg-[#29589e]  border-1 px-6 text-xs py-1 transition-all duration-300 ease-in-out"
                                        onClick={handleRemoveBtn}
                                      >
                                        Remove
                                      </button>
                                    )}
                                  </div>
                                )}

                                {isCouponApplied && coupon.amount && (
                                  <div className="flex flex-col gap-4 py-3 animate__animated animate__fadeInUp">
                                    {/* <div className="flex gap-2 text-md text-gray-700">
                                    <strong>Discount Amount:</strong>
                                    <p className="text-black flex items-center gap-1">
                                      <TbCurrencyRupee className="mt-[3px]" />
                                      {Number(coupon.discountAmount).toFixed(2)}
                                      {coupon.discountAmount}
                                    </p>
                                  </div> */}

                                    <div className="flex gap-2 text-md text-gray-700">
                                      <strong className="text-[#0E8872]">
                                        Cost After Discount:
                                      </strong>
                                      <p className="m-0 text-black-alpha-60 flex items-center gap-0">
                                        {/* <TbCurrencyRupee className="mt-[3px]" /> */}
                                        <span className="mr-1">INR</span>

                                        {/* {Number(coupon.amount + productResponse.shippingCost ).toFixed(2)} */}

                                        {productResponse?.shippingCost
                                          ? Number(
                                            coupon.amount +
                                            productResponse.shippingCost
                                          ).toFixed(2)
                                          : Number(coupon.amount)}

                                        {/* {coupon.amount} */}
                                        {productResponse?.costIncludedTax && (
                                          <sub className="ml-[3px] text-black-alpha-60 text-xs">
                                            {/* (inc. 18% GST) */}
                                          </sub>
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}

                            {availableMedium?.length > 0 && (
                              <div className=" max-w-sm flex items-center  bg-white  gap-2">
                                <FaRegDotCircle className="mr-3 text-[#7c8ec5]" />
                                <h2 className="text-sm text-[#0E8872] font-semibold ">
                                  Select Language
                                </h2>

                                <div className="flex items-center space-x-4">
                                  {availableMedium.map((m) => (
                                    <label className="flex items-center space-x-2 cursor-pointer">
                                      <input
                                        type="radio"
                                        name="medium"
                                        value={m}
                                        onChange={(e) =>
                                          setSelectedMedium(e.target.value)
                                        }
                                        className="text-blue-600 focus:ring-blue-500 border-gray-300"
                                      />
                                      <span className="text-gray-700">{m}</span>
                                    </label>
                                  ))}
                                </div>
                              </div>
                            )}

                            <div className="m-0 flex justify-center mb-6 ">
                              {productResponse.category ===
                                "659d195b4278df2b9163e8c6" ? (
                                <button
                                  type="submit"
                                  className="block mx-auto md:px-8 md:py-4 px-6 py-3  text-sm font-semibold rounded-md mb-3 shadow-md transition-all duration-300 ease-in-out text-[#000000] bg-[#FED442] hover:bg-[#d6aa08]  border-1    focus:outline-none"
                                  // onClick={buyWithAddress}
                                  onClick={() =>
                                    validateAndProceed(buyWithAddress)
                                  }
                                  loading={isloading}
                                >
                                  CONTINUE
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="block mx-auto md:px-8 md:py-4 px-6 py-3  text-sm font-semibold rounded-md mb-3 shadow-md transition-all duration-300 ease-in-out text-[#000000] bg-[#FED442] hover:bg-[#d6aa08]  border-1    focus:outline-none"
                                  // onClick={initiateOrder}
                                  onClick={() =>
                                    validateAndProceed(initiateOrder)
                                  }
                                  loading={isloading}
                                >
                                  CONTINUE
                                </button>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {page === "emiOption" && (
                    <div className="reg-card border-round-lg col-5 p-0">
                      <div className="w-full bg-color text-white text-2xl text-left px-3 py-3">
                        Select EMI Options
                      </div>
                      <div className="p-3">
                        <div className="text-right text-blue-500">
                          HAVE A COUPON CODE?
                        </div>
                        <div className="m-0 flex justify-content-center">
                          <button
                            type="submit"
                            className="p-0 px-4 py-2 bg-[#23cfce] text-white border-none border-round-sm cursor-pointer white-space-normal"
                          >
                            PAY NOW
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {page === "emiCouponError" && <div>Coupon Error</div>}
                  {page === "orderInitiated" && (
                    <div className="reg-card border-round-lg col-12 sm:col-10 md:col-8 xl:col-5 p-0 border-1 mx-4 shadow-lg">
                      <div className="w-full  rounded-[6px] text-[#25429e]  text-[10px] sm:text-[16px]  px-3 py-3 mb-2 text-center">
                        Order with this product previously Initiated
                        <br /> Please visit Order list to place your existing
                        orders.
                      </div>
                      <div className="m-0 flex justify-center pb-4 pt-2 ">
                        <button
                          type="submit"
                          className="p-0 px-4 py-2 rounded-[6px] bg-[#25429e] text-white text-[14px] sm:text-[16px] cursor-pointer"
                          onClick={() => goToDashboard()}
                        >
                          Go to Order Section
                        </button>
                      </div>
                    </div>
                  )}
                  {page === "couponInvalid" && (
                    <div className="reg-card border-round-lg col-5 p-0">
                      <div className="w-full bg-color text-white text-xl text-left px-3 py-3 mb-4">
                        Invalid Coupon Code
                      </div>
                      <div className="m-0 flex justify-content-center py-5">
                        <button
                          type="submit"
                          className="p-0 px-4 py-2 bg-color btn-color btn-hover  border-round-sm cursor-pointer white-space-normal"
                        >
                          Try Again
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* <Modal
            className="buy-dialog"
            isOpen={isOpen}
            onOpenChange={(open) => setIsOpen(open)}
          >
            <ModalContent>
              {(onClose) => (
                <div className="card flex justify-center p-0">
                  <div className="top-5 sm:top-10 w-full">
                    <Both initialScreen={initialScreen} />
                  </div>
                </div>
              )}
            </ModalContent>
          </Modal> */}

          {/* {isOpen && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"   onClick={() => setIsOpen(false)}>
                    <div className="relative bg-white w-full md:max-w-lg max-w-sm max-h-[500px] overflow-auto"     onClick={(e) => e.stopPropagation()}>
                 
                      <button
                        onClick={() => setIsOpen(false)}
                        className="absolute top-2 right-2 text-black hover:text-black text-xl"
                      >
                        ✕
                      </button>
          
                      <div className="card flex justify-center p-0">
                        <div className="top-5 sm:top-10 w-full">
                          <Both initialScreen={initialScreen} />
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}

          {isOpen && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="relative bg-white w-full md:max-w-4xl max-w-sm max-h-[90vh] rounded-lg flex flex-col">
                {/* Header with X (fixed area) */}

                <div className="flex justify-end px-6 border-b">
                  <div className="rounded-t-[8px] font-semibold text-[18px] sm:text-[24px] gap-[8px] flex items-center py-4  px-3 justify-center bg-white  mb-2 sticky z-[20]  w-full left-0 -top-4 ">
                    {currentScreen === "LOGIN" && "Login"}
                    {currentScreen === "REGISTER" && "Registration Form"}
                    {currentScreen === "FORGOT_PASSWORD" && "Forgot Password"}
                  </div>
                  <button
                    onClick={() => {
                      setIsOpen(false);
                      setCurrentScreen(null);
                    }}
                    className="text-black hover:text-gray-600 text-2xl font-bold"
                  >
                    ✕
                  </button>
                </div>
                {/* Scrollable content */}
                <div className="overflow-auto flex-1">
                  <Both
                    currentScreen={currentScreen}
                    setCurrentScreen={setCurrentScreen}
                    closeModal={() => {
                      setIsOpen(false);
                      setCurrentScreen(null);
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {addressModal === "open" && (
        <div className="fixed z-50 inset-0 flex items-center justify-center bg-black/60 p-4">
          <div className="bg-white rounded-2xl max-w-2xl w-full h-[85%] overflow-auto shadow-2xl">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-[#EEFBFF] sticky top-0 z-10">
              <h2 className="font-bold text-lg text-[#052c24]">Shipping Details</h2>
              <button
                onClick={() => setAddressModal("close")}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-[#FFD338] hover:bg-[#d6aa08] text-[#052c24] font-bold text-sm border border-black shadow-sm transition-colors"
              >
                ✕
              </button>
            </div>
            <div className="p-6">
            {/* <h2 className="text-lg font-bold mb-4 text-center">Address</h2> */}
            {error && <p className="text-red-500 text-center">{error}</p>}
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1  gap-6 w-full">
                <div>
                  <h3 className="font-bold text-center text-xl text-[#052c24] mb-4">
                    Shipping Address
                  </h3>

                  <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                    <div>
                      <label htmlFor="postalCode">
                        Postal Code <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="number"
                        name="postalCode"
                        placeholder="Postal Code"
                        value={addresses.shippingAddress.postalCode}
                        onChange={(e) => handleChange(e, "shippingAddress")}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none"
                      />
                    </div>

                    {loading ? (
                      <div className="flex justify-center items-center py-4">
                        <div className="w-8 h-8 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                      </div>
                    ) : (
                      <>
                        {shippingPostOffices.length > 0 && (
                          <div>
                            <label htmlFor="address">
                              Postal Area{" "}
                              <span className="text-red-600">*</span>
                            </label>
                            <select
                              onChange={(e) =>
                                handleBlockSelect(e, "shippingAddress")
                              }
                              value={selectedBlock.shippingAddress}
                              className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none"
                            >
                              <option value="">Select Postal Area</option>
                              {shippingPostOffices.map((block, index) => (
                                <option key={index} value={block.Name}>
                                  {block.Name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </>
                    )}

                    <div>
                      <label htmlFor="address">
                        Address <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="address"
                        placeholder="Address"
                        value={addresses.shippingAddress.address}
                        onChange={(e) => handleChange(e, "shippingAddress")}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none"
                      />
                    </div>

                    <div>
                      <label htmlFor="landmark">
                        Landmark <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="landmark"
                        placeholder="Landmark"
                        value={addresses.shippingAddress.landmark}
                        onChange={(e) => handleChange(e, "shippingAddress")}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none"
                      />
                    </div>

                    <div>
                      <label htmlFor="city">
                        City <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="city"
                        placeholder="City"
                        value={addresses.shippingAddress.city}
                        onChange={(e) => handleChange(e, "shippingAddress")}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none"
                      />
                    </div>

                    <div>
                      <label htmlFor="district">
                        District <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="district"
                        placeholder="District"
                        value={addresses.shippingAddress.district}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none disabled:bg-gray-100"
                        disabled={
                          addresses.shippingAddress.postalCode.length !== 6
                        }
                      />
                    </div>
                    <div>
                      <label htmlFor="state">
                        State <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="state"
                        placeholder="State"
                        value={addresses.shippingAddress.state}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none disabled:bg-gray-100"
                        disabled={
                          addresses.shippingAddress.postalCode.length !== 6
                        }
                      />
                    </div>
                    {/* <div>
                      <label htmlFor="State">Country</label>
                      <input
                        type="text"
                        name="country"
                        placeholder="Country"
                        value={addresses.shippingAddress.country}
                        className="block w-full p-2  border-1 border-[#ABABAB] rounded my-2"
                        disabled={
                          addresses.shippingAddress.postalCode.length !== 6
                        }
                      />
                    </div> */}
                  </div>
                </div>

                <div>
                  <div className="">
                    <label className="flex items-center my-2">
                      <input
                        type="checkbox"
                        checked={sameAsShipping}
                        onChange={(e) => {
                          handleSameAsShipping(e);
                          if (!sameAsShipping) {
                            handleChange(
                              {
                                target: {
                                  name: "postalCode",
                                  value: addresses.shippingAddress.postalCode,
                                },
                              },
                              "billingAddress"
                            );
                            setSelectedBlock((prev) => ({
                              ...prev,
                              billingAddress: selectedBlock.shippingAddress,
                            }));
                          }
                        }}
                        className="mr-2"
                      />
                      <span>Same as shipping address</span>
                    </label>
                    <h3 className="font-bold text-center text-xl text-[#052c24] my-4">
                      Billing Address
                    </h3>
                  </div>

                  <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                    <div>
                      <label htmlFor="postalCode">
                        Postal Code <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="number"
                        name="postalCode"
                        placeholder="Postal Code"
                        value={addresses.billingAddress.postalCode}
                        onChange={(e) => handleChange(e, "billingAddress")}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none disabled:bg-gray-100"
                        disabled={sameAsShipping}
                      />
                    </div>
                    {billingPostOffices.length > 0 && (
                      <div>
                        <label htmlFor="postalCode">
                          Postal Code <span className="text-red-600">*</span>
                        </label>
                        <select
                          onChange={(e) =>
                            handleBlockSelect(e, "billingAddress")
                          }
                          value={selectedBlock.billingAddress}
                          className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none disabled:bg-gray-100"
                          disabled={sameAsShipping}
                        >
                          <option value="">Select Postal Area</option>
                          {billingPostOffices.map((block, index) => (
                            <option key={index} value={block.Name}>
                              {block.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div>
                      <label htmlFor="address">
                        Address <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="address"
                        placeholder="Address"
                        value={addresses.billingAddress.address}
                        onChange={(e) => handleChange(e, "billingAddress")}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none disabled:bg-gray-100"
                        disabled={sameAsShipping}
                      />
                    </div>

                    <div>
                      <label htmlFor="landmark">
                        Landmark <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="landmark"
                        placeholder="Landmark"
                        value={addresses.billingAddress.landmark}
                        onChange={(e) => handleChange(e, "billingAddress")}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none disabled:bg-gray-100"
                        disabled={sameAsShipping}
                      />
                    </div>

                    <div>
                      <label htmlFor="city">
                        City <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="city"
                        placeholder="City"
                        value={addresses.billingAddress.city}
                        onChange={(e) => handleChange(e, "billingAddress")}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none disabled:bg-gray-100"
                        disabled={sameAsShipping}
                      />
                    </div>

                    <div>
                      <label htmlFor="district">
                        District <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="district"
                        placeholder="District"
                        value={addresses.billingAddress.district}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none disabled:bg-gray-100"
                        disabled={
                          sameAsShipping ||
                          addresses.shippingAddress.postalCode.length !== 6
                        }
                      />
                    </div>

                    <div>
                      <label htmlFor="state">
                        State <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        name="state"
                        placeholder="State"
                        value={addresses.billingAddress.state}
                        className="block w-full p-2 border border-[#052c24] rounded-lg my-2 focus:ring-2 focus:ring-[#FFD338] focus:outline-none disabled:bg-gray-100"
                        disabled={
                          sameAsShipping ||
                          addresses.shippingAddress.postalCode.length !== 6
                        }
                      />
                    </div>

                    {/* <div>
                    <label htmlFor="state">Country</label>

                    <input
                      type="text"
                      name="country"
                      placeholder="Country"
                      value={addresses.billingAddress.country}
                      className="block w-full p-2  border-1 border-[#ABABAB] rounded my-2"
                      disabled={
                        sameAsShipping ||
                        addresses.shippingAddress.postalCode.length !== 6
                      }
                    />
                  </div> */}
                  </div>
                </div>
              </div>

              <div className="text-center mt-6 pb-4">
                <button
                  type="submit"
                  disabled={loading}
                  className={`text-[#052c24] font-semibold p-2 px-8 py-3 rounded-lg border border-black shadow-[0px_4px_10px_rgba(0,0,0,0.3)] transition-all ${loading
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-[#FFD338] hover:bg-[#d6aa08]"
                    }`}
                >
                  {loading ? "Loading..." : "Save Address"}
                </button>
              </div>

              {/* <button
                onClick={() => setAddressModal("close")}
                type="button"
                className="bg-gray-500 text-white p-2 mt-2 w-full rounded-lg"
              >
                Close
              </button> */}
            </form>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
